import React, { useState } from "react";
import DataTable from "react-data-table-component";
import ColorsMain from "../../colors/ColorsMain";
import "./table.css";
import moment from "moment/moment";
import { FaArrowRightLong } from "react-icons/fa6";

import { FaRegClock, FaRegCalendarAlt } from 'react-icons/fa';
const CustomTable = ({ data, totalRows, newPerPage, handlePageChange, handleChange, pending, handle, columns, loadingTable }) => {
  const customStyles = {
    headRow: {
      style: {
        borderBottom: "none",
      },
    },
    tableWrapper: {
      style: {
        overflow: "hidden",
        border: "none",
      },
    },
    rows: {
      style: {
        backgroundColor: "#1a1b22",
        color: "#ffffff",
        borderBottom: "none",
        transition: "background-color 0.4s ease",
        "&:hover": {
          backgroundColor: "#26262c",
          borderRadius: 8,
          cursor: "pointer",
        },
      },
    },
    headCells: {
      style: {
        borderBottom: "none",
        backgroundColor: "#1a1b22",
        color: "#8A8A8E",
        fontSize: "14px",
        fontWeight: "bold",
        padding: "10px",
      },
    },
    cells: {
      style: {
        borderBottom: "none",
        padding: "10px",
      },
    },
    pagination: {
      style: {
        borderColor: "#5E5E63",
        backgroundColor: "#1a1b22",
        color: "#ffffff",
      },
      pageButtonsStyle: {
        color: "#ffffff",
        fill: "#ffffff",
        "&:disabled": {
          color: "#8A8A8E",
          fill: "#8A8A8E",
          cursor: "not-allowed",
        },
      },
    },
    table: {
      style: {
        backgroundColor: "#1a1b22",
      },
    },
    noData: {
      style: {
        backgroundColor: "#1a1b22",
        color: "white",
        textAlign: "center",
        padding: "20px",
      },
    },
  };

  const paginationOptions = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };




  // 🔥 Skeleton Table: Se muestra cuando `loadingTable === true`
  const SkeletonTable = () => {
    const columnCount = columns.length;
    console.log("columnCount", columnCount);

    return (
      <div className="w-full p-4 bg-[#1a1b22] rounded-lg">
        {/* Encabezados falsos */}
        {/*  <div className={`grid grid-flow-col grid-cols-${columnCount}  border-b border-gray-800 py-3  `}>
          {columns.map((col, index) => (
            <div key={index} className=" h-6 w-24 bg-gray-700 rounded animate-pulse "></div>
          ))}
        </div> */}

        {/* Filas falsas */}
        {Array.from({ length: 10 }).map((_, rowIndex) => (
          <div key={rowIndex} className={`grid grid-flow-col grid-cols-${columnCount}  border-b border-gray-800 py-3 items-center`}>
            {/* Actividad */}
            <div className="flex items-center gap-2">
              <div className="rounded-full bg-gray-700 w-6 h-6 animate-pulse"></div>
              <div className="flex flex-col">
                <div className="h-4 w-20 bg-gray-700 rounded animate-pulse"></div>
                <div className="h-3 w-16 bg-gray-700 rounded animate-pulse mt-1"></div>
              </div>
            </div>

            {/* Usuario */}
            {Array.from({ length: columnCount === 6 ? 3 : 2 }).map((_, index) => (
              <div key={index} className="h-6 w-24 bg-gray-700 rounded animate-pulse"></div>
            ))}

            {/* Fecha y hora */}
            <div className="flex items-center gap-2 text-gray-400">
              <FaRegCalendarAlt size={14} className="text-gray-600" />
              <div className="h-4 w-20 bg-gray-700 rounded animate-pulse"></div>
              <FaRegClock size={14} className="text-gray-600" />
              <div className="h-4 w-16 bg-gray-700 rounded animate-pulse"></div>
            </div>

            {columnCount > 5 && <div className="h-6 w-24 bg-gray-700 rounded animate-pulse"></div>}
          </div>
        ))}
      </div>
    );
  };



  return (
    <div className="flex w-full h-full flex-col" style={{ background: ColorsMain.bgDark }}>
      <div className=" " style={{ background: ColorsMain.bgMain, borderWidth: 3, borderRadius: 12, borderColor: ColorsMain.bgMain }}>
        <div>
          {loadingTable ? (
            <SkeletonTable /> // ✅ Muestra la tabla ficticia mientras carga
          ) : (
            <DataTable
              noHeader
              onChangePage={handlePageChange}
              columns={columns}
              data={data}
              paginationComponentOptions={paginationOptions}
              customStyles={customStyles}
              paginationTotalRows={totalRows}
              paginationPerPage={newPerPage}
              pagination
              paginationRowsPerPageOptions={[10, 25, 50, 100, 200]}
              noDataComponent={"No hay movimientos disponibles"}
              highlightOnHover={false}
              /*    onRowClicked={(row) => handle(row)} */
              progressPending={pending}
              progressComponent={
                <div className="flex md:flex-row flex-wrap p-4 w-full " style={{ background: ColorsMain.bgMain }}>
                  <div className="w-full" >
                    <div style={{ height: "50vh", }}>
                      <div className="h-full w-full flex items-center justify-center">
                        <div className="spinner-border animate-spin w-14 h-14 border-4 border-white border-t-transparent rounded-full"></div>

                      </div>
                    </div>
                  </div>
                </div>
              }
              paginationServer
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomTable;
